export default "__VITE_ASSET__DcwGGz2h__"